import React from 'react'
import TableUserView from '../../presentational/user/TableUserView'

const TableUserGroup = ({
    dataTableState,

    onEdit,
    onDelete
}) => {

    const handleRowClick = (data, type) => {
        if (type === 'edit') {
            onEdit(data)
        } else {
            onDelete(data)
        }
    }

    return (
        <TableUserView
            dataTableState={dataTableState}
            onRowClick={handleRowClick}
        />
    )
}

export default TableUserGroup